import {UIGameToolTipView} from './ui_game/ui_game_tooltip/UIGameToolTipView'
import {PIXI} from '@colonist/pixi'

export class GameUIToolTips {
    static tips: UIGameToolTipView[] = []

    static removeAllToolTips() {
        for(const tip of this.tips) {
            this.removeToolTip(tip)
        }
    }

    private static removeToolTip(tip: UIGameToolTipView) {
        tip.parent.removeChild(tip)
        const index = this.tips.indexOf(tip, 0)
        if(index > -1) this.tips.splice(index, 1)
    }

    static remove(view: PIXI.Container) {
        for(const tip of this.tips) {
            if(tip.viewToPlaceNear != view) continue
            this.removeToolTip(tip)
        }
    }
}
